// @flow

class InfoAlert {
    static localStorageKey = "info-alert";

    el: HTMLElement;
    timestamp: string;
    close: ?HTMLElement;
    nav: ?HTMLElement;
    closedAlerts: string[];
    spacer: ?HTMLElement;

    constructor(el: HTMLElement) {
        this.el = el;
        this.timestamp = this.el.getAttribute("data-alert-timestamp") || "";
        this.close = this.el.querySelector(".info-alert__close");
        this.nav = document.querySelector(".primary-nav__inner");
        this.spacer = document.querySelector(".info-alert-spacer");

        this.closedAlerts =
            JSON.parse(
                localStorage.getItem(InfoAlert.localStorageKey) || "[]"
            ) || [];

        this.checkIfInLocalStorage();
        this.attachEvents();
    }

    attachEvents = () => {
        if (this.close) {
            this.close.addEventListener("click", () => {
                this.closeAlertMessage();
            });
        }
        this.positionEls();
        window.addEventListener("resize", this.positionEls);
    };

    checkIfInLocalStorage = () => {
        if (this.closedAlerts.length === 0) {
            // Show alert if there are no alerts
            this.showElement();
        } else {
            // Otherwise hide any that have already been closed
            this.closedAlerts.forEach((timestamp: string) => {
                if (timestamp === this.timestamp) {
                    this.removeElement();
                }
            });
        }
    };

    positionEls = () => {
        const nav = this.nav;
        const spacer = this.spacer;

        if (!nav || !spacer) return;

        if (!this.el.classList.contains("visible")) {
            nav.style.transform = "translateY(0px)";
            spacer.style.height = "0px";
        } else {
            this.showElement();
            nav.style.transform = `translateY(${this.el.clientHeight}px)`;
            spacer.style.height = `${this.el.clientHeight}px`;
        }
    };

    closeAlertMessage = () => {
        this.closedAlerts = [...this.closedAlerts, this.timestamp];
        localStorage.setItem(
            InfoAlert.localStorageKey,
            JSON.stringify(this.closedAlerts)
        );
        this.removeElement();
        this.positionEls();
    };

    removeElement = () => {
        this.el.classList.remove("visible");
    };

    showElement = () => {
        this.el.classList.add("visible");
    };
}

const els = document.querySelectorAll(".info-alert");
els.forEach((el: HTMLElement) => {
    new InfoAlert(el);
});
